import PageLayout from "../../components/common/page-layout";
import Logs from "../../components/doc-scanning/logs/logs";
import { RequireAuth } from "../../hooks/use-auth";

/** Per-document ingestion results, newest first, filterable by company. */
const LogsPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        maxWidth={false}
        subtitle="Ingested documents across both pipelines"
        title="Scan logs"
      >
        <Logs />
      </PageLayout>
    </RequireAuth>
  );
};

export default LogsPage;
